<template>
  <div>
    <SnackbarComponent
      v-model="snackbar.show"
      :message="snackbar.message"
      :color="snackbar.color"
    />
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h6 pa-4">
          Confirm Unpublish Announcement
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-6">
          <div class="text-body-1">
            Are you sure you want to unpublish this announcement?
          </div>
          <div v-if="announcement" class="mt-3">
            <div class="text-body-2">
              <strong>Message:</strong>
              <div
                v-html="
                  announcement.announcement_message
                    ? announcement.announcement_message.substring(0, 100) +
                      (announcement.announcement_message.length > 100 ? '...' : '')
                    : '-'
                "
              ></div>
            </div>
            <div class="text-body-2 mt-2">
              <strong>Current Status:</strong> {{ announcement.announcement_status || '-' }}
            </div>
          </div>
          <div class="text-caption text-medium-emphasis mt-2">
            The announcement will be hidden from users but can be republished later.
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            variant="text"
            @click="handleClose"
            :disabled="loading"
          >
            Cancel
          </v-btn>
          <v-btn
            color="warning"
            variant="flat"
            @click="handleUnpublish"
            :loading="loading"
          >
            Unpublish
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { edit_announcement } from "@/graphql/mutations";
import SnackbarComponent from "@/components/Extras/Snackbar.vue";

export default {
  name: "UnpublishAnnouncementDialog",
  components: {
    SnackbarComponent,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    announcement: {
      type: Object,
      default: null,
    },
  },
  emits: ["update:modelValue", "unpublished"],
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: "",
        color: "success",
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    handleClose() {
      this.dialog = false;
    },
    async handleUnpublish() {
      if (!this.announcement?.announcement_id) {
        return;
      }

      this.loading = true;
      try {
        const input = {
          announcement_id: this.announcement.announcement_id,
          announcement_status: "UNPUBLISH",
          announcement_source: "BMS",
        };

        const response = await client.graphql({
          query: edit_announcement,
          variables: {
            input: input,
          },
        });

        const responseData = JSON.parse(response.data.edit_announcement);
        // console.log(responseData);

        if (responseData.status === "SUCCESS") {
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Announcement unpublished successfully!",
            color: "success",
          };
          this.dialog = false;
          this.$emit("unpublished");
        } else {
          this.snackbar = {
            show: true,
            message: responseData.status_message || "Failed to unpublish announcement",
            color: "error",
          };
        }
      } catch (error) {
        console.error("Error unpublishing announcement:", error);
        this.snackbar = {
          show: true,
          message: (error.errors && error.errors[0]?.message) || error.message || "An error occurred while unpublishing announcement",
          color: "error",
        };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
